import { observer } from 'mobx-react';
import { HeaderSection } from '../../LearningSkeleton';

function HeaderSkeleton() {
  return (
    <div className="w-full px-11 bg-white border-b mb-px">
      <HeaderSection />
    </div>
  );
}

export default observer(HeaderSkeleton);
